// BarcodeRegistration.jsx
import React from "react";

export default function BarcodeRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Barcode Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Barcode Registration for Products in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses with Barcode Registration
            for product identification and compliance, helping you obtain
            standardized barcodes that can be used across retail, online, and
            supply-chain platforms.
          </p>
          <p className="text-gray-700">
            From organizing business details and product information to guiding
            you on the registration process with the relevant authority, the
            service is structured so that your products can be uniquely
            identifiable and distribution-ready.
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/4482900/pexels-photo-4482900.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Barcode labels being checked for products"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Barcode Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps businesses collate and format the
              primary information and documents necessary for a smooth barcode
              registration process.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Business registration certificate (certificate of
                  incorporation, GST registration, or other relevant registration
                  proof).
                </li>
                <li>
                  PAN card of the entity or proprietor, depending on the type of
                  business.
                </li>
                <li>
                  Basic product details including product name, category, and
                  variants for which barcodes are required.
                </li>
                <li>
                  Contact information of the authorized signatory (name, mobile,
                  email, designation).
                </li>
                <li>
                  Bank details or basic financial information if required by the
                  registration authority.
                </li>
                <li>
                  Any additional letters or declarations on business letterhead
                  requesting barcode allotment, where applicable.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm provides barcode-related support with a focus on
              industry practices and documentation accuracy, helping businesses
              integrate barcodes smoothly into their operations.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Industry Compliance Knowledge
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on using standardized barcodes for retail, exports,
                  and online marketplaces so that product identification aligns
                  with common industry expectations.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Registration Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in presenting correct business and product details in
                  applications, helping reduce errors and follow-up queries
                  during barcode allotment.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Service Delivery
                </h3>
                <p className="text-gray-700 text-sm">
                  Process-driven assistance from initial information gathering
                  through application and follow-up, providing reliable support
                  for your barcode registration needs.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
